import { createStore } from 'vuex'
import { setToken, removeToken } from '@/utils/auth'
import createPersistedState from "vuex-persistedstate";
export default createStore({
  state: {
    userInfo: {},
    agreement: 0, // 1记住密码 0默认
    loging: false
  },
  getters: {
  },
  mutations: {
    set_user(state, data) {
      state.userInfo = data
      state.agreement = data.agreement
      setToken(data.token)
      state.loging = true
    },
    set_agreement(state, data) {
      state.agreement = data
    },
    set_headimg(state, data) {
      state.userInfo.headImg = data
    },
    logout(state) {
      localStorage.setItem("inforStatus", "1"); //是否完善信息
      state.userInfo = {}
      removeToken()
      state.loging = false
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
